module.exports = __webpack_public_path__ + "static/question-fb2aaff49264a3b1306c6f43c1097404.png";